// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2663":"d4eb2986","3542":"bc3c2e7d","3682":"d4eb2986","7151":"bc3c2e7d","9727":"d4eb2986","9821":"bc3c2e7d"}[chunkId] + ".chunk.css";
};